import React from "react";
import Footer from "../core/common/footer/Footer";
import { Link } from "react-router-dom";

const Support = () => {
  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
          <div className="card-body p-3 p-md-4 p-lg-5">
            {/* Header */}
            <div className="text-center mb-4 mb-md-5">
              <div
                className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                style={{
                  width: "76px",
                  height: "76px",
                  background: "rgba(242, 101, 34, 0.10)",
                }}
              >
                <i
                  className="bi bi-headset"
                  style={{ fontSize: "38px", color: "#f26522" }}
                />
              </div>

              <h2 className="fw-bold mb-2">Aupertz Support Center</h2>

              <p
                className="text-muted mb-0 mx-auto"
                style={{ maxWidth: "600px" }}
              >
                If you require any assistance during your background
                verification process, our support team is available to help.
              </p>
            </div>

            {/* Contact Details */}
            <div className="border rounded-4 overflow-hidden">
              {/* Email */}
              <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3 p-3 p-md-4 border-bottom">
                <div className="d-flex align-items-center gap-3">
                  <div
                    className="rounded-3 d-flex align-items-center justify-content-center flex-shrink-0"
                    style={{
                      width: "54px",
                      height: "54px",
                      background: "#eef4ff",
                    }}
                  >
                    <i className="bi bi-envelope fs-3 text-primary" />
                  </div>

                  <div>
                    <h6 className="fw-semibold mb-1">Email Support</h6>
                    <small className="text-muted">
                      For general support & verification queries
                    </small>
                  </div>
                </div>

                <div className="ps-0 ps-md-3 text-md-end">
                  <a
                    href="mailto:candidatesupport@aupertz.co.in"
                    className="fw-semibold text-decoration-none text-break"
                  >
                    candidatesupport@aupertz.co.in
                  </a>
                </div>
              </div>

              {/* Working Hours */}
              <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3 p-3 p-md-4 border-bottom">
                <div className="d-flex align-items-center gap-3">
                  <div
                    className="rounded-3 d-flex align-items-center justify-content-center flex-shrink-0"
                    style={{
                      width: "54px",
                      height: "54px",
                      background: "#fff4e9",
                    }}
                  >
                    <i
                      className="bi bi-clock fs-3"
                      style={{ color: "#f26522" }}
                    />
                  </div>

                  <div>
                    <h6 className="fw-semibold mb-1">Working Hours</h6>
                    <small className="text-muted">Monday - Saturday</small>
                  </div>
                </div>

                <div className="ps-0 ps-md-3 text-md-end">
                  <span className="fw-semibold">09:00 AM - 07:00 PM IST</span>
                </div>
              </div>

              {/* Website */}
              {/* <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3 p-3 p-md-4">
                <div className="d-flex align-items-center gap-3">
                  <div
                    className="rounded-3 d-flex align-items-center justify-content-center flex-shrink-0"
                    style={{
                      width: "54px",
                      height: "54px",
                      background: "#eaf8f0",
                    }}
                  >
                    <i className="bi bi-globe fs-3 text-success" />
                  </div>

                  <div>
                    <h6 className="fw-semibold mb-1">Website</h6>
                    <small className="text-muted">
                      Learn more about Aupertz
                    </small>
                  </div>
                </div>

                <div className="ps-0 ps-md-3 text-md-end">
                  <a
                    href="https://www.auptech.in"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="fw-semibold text-decoration-none text-break"
                  >
                    www.auptech.in
                    <i className="bi bi-box-arrow-up-right ms-2 small" />
                  </a>
                </div>
              </div> */}
            </div>

            {/* Support Information */}
            <div
              className="rounded-4 mt-4 mt-md-5 p-3 p-md-4"
              style={{
                background: "#fff8f4",
                border: "1px solid #ffe2d3",
              }}
            >
              <div className="d-flex align-items-start gap-3">
                <div className="flex-shrink-0">
                  <i
                    className="bi bi-info-circle-fill fs-3"
                    style={{ color: "#f26522" }}
                  />
                </div>

                <div>
                  <h6 className="fw-bold mb-3">Before Contacting Support</h6>

                  <ul className="text-muted ps-3 mb-0">
                    <li className="mb-2">
                      Keep your <strong>Case ID</strong> or{" "}
                      <strong>Candidate ID</strong> ready.
                    </li>

                    <li className="mb-2">
                      Mention your registered mobile number or email address.
                    </li>

                    <li>
                      Describe your issue clearly to help us resolve it faster.
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Bottom Note */}
            <div className="text-center mt-4">
              <small className="text-muted">
                <i className="bi bi-shield-check me-1 text-success" />
                We are committed to providing you with reliable support.
              </small>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Support;
